module.exports = __webpack_public_path__ + "static/thumbnail_miRNA_atlas-db504cce9bed702dbd779bb186bfe5c6.png";